<template>
 <b-card>
    <div class="d-flex align-items-center">
      <feather-icon icon="GridIcon" size="20" />
      <span style="font-weight: 700; font-size: 16px; margin-left: 10px"
        >Mapping Sport Cast => Sporting Solutions </span
      >

       <b-button
        variant="outline-primary"
        class="ml-2"
        size="sm"
        @click="$bvModal.show('league-mapping')"
      >
        League Mapping
      </b-button>
      <b-button
        variant="outline-primary"
        class="ml-2"
        size="sm"
        @click="$bvModal.show('team-mapping')"
      >
        Team Name Mapping
      </b-button>
    </div>

    <LeagueMappingModal />
    <TeamMappingModal />

 </b-card>
</template>

<script>
import useToastHandler from "@/services/toastHandler";
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BIcon,
  BFormCheckbox,
  BFormInput,
  BCardText,
} from "bootstrap-vue";
import { mapActions, mapState } from "vuex";
import draggable from "vuedraggable";
import Spinner from "@/@core/components/Spinner.vue";
import vSelect from "vue-select";
import MarketGroupConfig from "./MarketGroupConfig.vue";
import MappingH2HModal from "./MappingH2HModal.vue";
import CrawlingLineTotalModal from "./CrawlingLineTotalModal.vue";
import LeagueMappingModal from "./LeagueMappingModal.vue";
import TeamMappingModal from "./TeamMappingModal.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
    BFormCheckbox,
    draggable,
    BFormInput,
    BCardText,
    Spinner,
    vSelect,
    MarketGroupConfig,
    MappingH2HModal,
    CrawlingLineTotalModal,
    LeagueMappingModal,
    TeamMappingModal,
  },
  data() {
    return {
      sports: [],
      checkActiveSport: true,
      selectedSport: null,
      leagues: [],

      dataMarket: null,
      marketNames: [],
      newLeagueName: "",
      activeSource: "sporting",
      optionsSource: [
        { label: "Sporting", value: "sporting" },
        { label: "RAS", value: "RAS" },
        { label: "Pricekinetic", value: "pricekinetic" },
        { label: "Manual", value: "manual" },
      ],
      modalTitle: "",

      modal: {
        title: "",
        content: "",
      },
      action: {
        type: "",
        id: "",
      },
    };
  },
  async mounted() {
    await this.fetchSports();
    this.selectedSport = this.sports[0];
  },
  watch: {
    checkActiveSport(val) {
      this.fetchSports();
    },
    selectedSport() {
      this.fetchLeagueIgnoreConfig();
    },
  },
  computed: {
    ...mapState("trading/config", ["loadingCreateNewConfig", "loadingDelete"]),
    isLoading() {
      return this.loadingCreateNewConfig || this.loadingDelete;
    },
  },
  methods: {
    ...mapActions({
      getListSport: "sport/list/getListSport",
      getListLeagueConfig: "trading/config/getListLeagueConfig",
      deleteLeagueConfig: "trading/config/deleteLeagueConfig",
      createNewLeagueConfig: "trading/config/createNewLeagueConfig",
    }),
    async fetchSports() {
      const data = await this.getListSport({
        limit: 100,
        page: 1,
        ...(this.checkActiveSport && { status: "active" }),
        source: this.activeSource,
      });
      if (!data && data.data.length <= 0)
        return this.showToastError(false, "Error fetching sports list");
      this.sports = data.data;
    },
    async fetchLeagueIgnoreConfig() {
      const data = await this.getListLeagueConfig({
        sportId: this.selectedSport.id,
      });
      if (Array.isArray(data.data)) {
        this.leagues = data.data;
      }
    },
    async selectSport(sport) {
      this.selectedSport = sport;
    },

    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },
    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete")
        this.setModal(
          "Delete Leauge",
          `Are you sure you want to delete league name ${item.leagueName.toUpperCase()}?`
        );

      this.$refs.modal.show();
    },
    async handleSubmitModal(event) {
      event.preventDefault();
      const { type, item } = this.action;
      if (type === "delete") await this.handleDelete(item);

      if (!this.isLoading) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleSaveDataConfig(event) {
      event.preventDefault();
      if (!this.newLeagueName)
        return this.showToastError(false, "Please enter league name");
      const res = await this.createNewLeagueConfig({
        sportId: this.selectedSport.id,
        source: this.activeSource,
        leagueNames: [this.newLeagueName],
      });
      if (res) {
        this.showToastSuccess(
          true,
          "List leagues config updated successfully!"
        );
        this.$refs.config.hide();
        this.fetchLeagueIgnoreConfig();
      }
    },
    showModalAddConfig() {
      this.modalTitle = "New Config";
      this.$refs.config.show();
    },
    hideModalSetting() {
      this.newLeagueName = "";
    },
    async handleDelete(item) {
      const res = await this.deleteLeagueConfig({
        sportId: this.selectedSport.id,
        id: item.id,
      });
      if (res) {
        this.showToastSuccess(true, "League deleted successfully!");
        this.fetchLeagueIgnoreConfig();
      }
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>


<style lang="scss" scoped>
.border-bot {
  border-bottom: 1px solid #dae1e7;
}

.active-item {
  color: #0d6efd;
  font-weight: bold;
  border-left: 2px solid #0d6efd;
  background: #e7f1ff;
}

.market-outline {
  padding: 20px;
  border: 1px solid #dae1e7;
  border-radius: 10px;
}
</style>